/**
 * @flow
 * @format
 */
import _AnalysisWrapper from './AnalysisWrapper';

export default _AnalysisWrapper;



// WEBPACK FOOTER //
// ./src/components/AnalysisWrapper/index.js